__turbopack_context__.v({
  "container": "-vSXGW_container",
  "contentContainer": "-vSXGW_contentContainer",
  "energyEfficiency": "-vSXGW_energyEfficiency",
  "energyEfficiencyButton": "-vSXGW_energyEfficiencyButton",
});
